import type { OpenPosition } from "@/common/api/open-position/use-open-position-search.query";
import { DeviceType } from "@/common/hooks/use-device";
import type { ImplementedColumnDef } from "@/components/data-table/types";
import { FiaTrackingSource } from "@/modules/fia/fia.tracking";
import { openPositionColumns } from "@/modules/fia/open-position/positions/open-position-columns";
import { OpenPositionTable } from "@/modules/fia/open-position/positions/open-position-table";
import { useMemo, type ReactElement } from "react";

const OPEN_POSITIONS_TAB_COLUMNS = [
  openPositionColumns.invoiceNumber,
  { ...openPositionColumns.type, visibility: [DeviceType.Tablet, DeviceType.Desktop, DeviceType.Widescreen] },
  openPositionColumns.amount,
  openPositionColumns.dueDate,
  { ...openPositionColumns.dunningLevel, visibility: [DeviceType.Desktop, DeviceType.Widescreen] },
  { ...openPositionColumns.dunningReason, visibility: [DeviceType.Tablet, DeviceType.Desktop, DeviceType.Widescreen] },
  { ...openPositionColumns.customer, visibility: [DeviceType.Tablet, DeviceType.Desktop, DeviceType.Widescreen] },
] as ImplementedColumnDef<OpenPosition, unknown>[];

export function OpenPositionsTab({ branchUuid }: { branchUuid: string }): ReactElement {
  const body = useMemo(() => ({ branch: [branchUuid] }), [branchUuid]);

  return (
    <OpenPositionTable
      name={`open-positions-${branchUuid}`}
      body={body}
      columns={OPEN_POSITIONS_TAB_COLUMNS}
      trackingSource={FiaTrackingSource.BranchDetail}
    />
  );
}
